import { locale } from '../config';
import { SupportedLocale } from './types';

export const DEFAULT_LOCALE = locale;
export const LOCALES: SupportedLocale[] = ['cs', 'en'];

export const FREESHIPPINGLIMIT_BY_CART_SUBJECTS_QUANTITY_FOR_EXTERNAL_COMPANY_ID: Partial<Record<string, number>> = {
  '15f110ea-9121-4cc5-9c74-d33142ec2b9a': 25, // Klier CZ
  'f493b4b2-1ad2-4641-88a9-2b7501454bc4': 25, // Klier SK
};
